'use client';

import { useEffect, useState } from 'react';

import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { MobileSearchProvider } from '@eliadmin/core/src/components/header/mobile-search';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Topbar } from './topbar';
import { HeaderContent } from './header-content';

export type HeaderMainProps = {
  generalLayout: GeneralLayout['data'];
  categories: CategoriesEntity[];
  menu: Menu;
};

export function HeaderMain({ generalLayout, menu, categories }: HeaderMainProps) {
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [isScrolledUp, setIsScrolledUp] = useState<boolean>(false);
  const [lastScrollY, setLastScrollY] = useState<number>(0);
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 1) {
        setIsScrolledUp(false);
      } else if (currentScrollY < lastScrollY && Math.abs(currentScrollY - lastScrollY) > 1) {
        setIsScrolledUp(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <MobileSearchProvider>
      <div
        className={cn(
          'fixed top-0 z-[39] w-full transition-all duration-300 ease-in-out',
          isSearchOpen && 'z-[80]',
          isSidebarOpen && 'z-[20]',
        )}
      >
        {/* <Topbar
          generalLayout={generalLayout}
          className={cn('transition-all duration-300 ease-in-out top-0 left-0 w-full')}
        /> */}
        <HeaderContent
          setIsSearchOpen={setIsSearchOpen}
          categories={categories}
          generalLayout={generalLayout}
          menu={menu}
          scrolled={scrolled}
          searchBarScrolled={scrolled && !isScrolledUp}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
    </MobileSearchProvider>
  );
}
